export default {
      id: "planner-calibrate-usage",
      viewBox: "0 0 10 10",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#planner-calibrate",
      toString: function () {
        return this.url;
      }
    }